import { Navigate, useLocation } from 'react-router-dom'

import { useWorkspaceSlug } from '~/api/swr/useWorkspaceSlug.ts'

import { Spinner } from './Loading/index.tsx'

export function RedirectToWorkspacePage() {
  const location = useLocation()
  const { slug, isLoading, isFirstWorkspace } = useWorkspaceSlug()

  if (!slug && isLoading) {
    return <Spinner className="loading--page" />
  }

  if (!slug && !isLoading && isFirstWorkspace) {
    return <Navigate to="/c/create-workspace" />
  }

  const pathname = location.pathname.replace('/c/', `/c/${slug}/`)

  return (
    <Navigate
      to={{
        ...location,
        pathname,
      }}
    />
  )
}
